import * as React from 'react'

interface HeaderProps {
  name?: string
}

export default ({ name = 'Header' }: HeaderProps) => <header>{name}</header>



// WEBPACK FOOTER //
// ./src/containers/Header/index.tsx